import { logError } from '@node-space/utils'
import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getPayFees } from 'services/WalletsService'

export const usePayFeesQuery = (walletId: number, amount?: number, enabled = true) => {
  const {
    data: payFees,
    isError: payFeesError,
    isFetching: fetchingPayFees,
    isLoading: loadingPayFees,
    refetch: refetchPayFees,
  } = useQuery({
    queryKey: reactQueryKeys.payFees(walletId, amount),
    queryFn: async () => {
      const response = await getPayFees(walletId, amount)

      return response.data
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled,
    keepPreviousData: false,
    onError(err) {
      logError('Error from useBanksQuery', err, {
        walletId,
        amount,
      })
    },
  })

  return {
    payFees,
    payFeesError,
    fetchingPayFees,
    loadingPayFees,
    refetchPayFees,
  }
}
